<div>
  <div class="flex--row flex--align-center flex--nowrap">
    <h3 class="text--h5">{{ title | translate }}</h3>
    @if (showInitialStockMatchesRvo) {
      <ng-container *ngComponentOutlet="initialStockRvoCheckComponent"></ng-container>
    }
  </div>

  @if (tableConfig && tableConfig.dataSource.data.length > 0) {
    <agr-table class="fertilizers-table" [config]="tableConfig"></agr-table>
  } @else {
    <p class="no-data-message">{{ 'fertilizers.table.noDataAvailable' | translate }}</p>
  }
  <ng-template #periodIdCell let-row="row">
    <div>{{ row.periodName }}</div>
  </ng-template>
  <ng-template #soilTypeIdCell let-row="row">
    <div>{{ row.soilTypeName }}</div>
  </ng-template>
  <ng-template #cropAidIdCell let-row="row">
    <div>{{ row.cropAidDisplayName }}</div>
  </ng-template>
  <ng-template #dosageCell let-row="row">
    <div>{{ row.dosageDisplay }}</div>
  </ng-template>
</div>
